<script lang="tsx">
import { defineComponent, computed, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { genHouseDemolitionEntryDataSource } from '../../tools'
import { calcMulAmount, sumDecimalBy } from '../../calc'

const [name] = createNamespace('HouseDemolitionCompEntryDisplay')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtZch.CompData>>
    },
    standard: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    }
  },
  setup(props, { expose }) {
    const dataSource = computed(() => genHouseDemolitionEntryDataSource(props.data!))

    /** 单行金额：数量 * 标准 */
    const getRowTotal = (key: string) => calcMulAmount(props.data?.[key], props.standard?.[key])

    const totalAmount = computed(() => sumDecimalBy(dataSource.value, record => getRowTotal(record.key)))

    const columns: TableColumnType[] = [
      {
        title: '类别',
        dataIndex: 'type',
        width: 300,
        customRender({ text }) {
          return <span innerHTML={text}></span>
        }
      },
      {
        title: '单位',
        dataIndex: 'unit',
        width: 50,
        customRender() {
          return '平方米'
        }
      },
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 100,
        customRender({ record }) {
          return props.standard?.[record.key] ?? 0
        }
      },
      {
        title: '数量',
        dataIndex: 'count',
        width: 50,
        customRender({ record }) {
          return props.data?.[record.key] ?? 0
        }
      },
      {
        title: '金额(元)',
        dataIndex: 'total',
        width: 100,
        customRender({ record }) {
          return getRowTotal(record.key).toFixed(2)
        }
      }
    ]

    const renderFooter = () => {
      return <div class='ant-calc-table-footer'>小计金额：{totalAmount.value.toFixed(2)} 元</div>
    }

    expose({
      totalAmount
    })
    return () => (
      <Table pagination={false} columns={columns} dataSource={dataSource.value} size='small' footer={renderFooter} class='ant-calc-table' />
    )
  }
})
</script>
